"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("@emotion/react");

var Global = function Global(_ref) {
  var _ref$isAppWebview = _ref.isAppWebview,
      isAppWebview = _ref$isAppWebview === void 0 ? false : _ref$isAppWebview;
  var theme = (0, _react.useTheme)();
  return (0, _jsxRuntime.jsx)(_react.Global, {
    styles: {
      ':any-link': {
        textDecoration: 'none'
      },
      '*': {
        boxSizing: 'border-box'
      },
      '.title1': {
        color: theme.colors.title,
        fontFamily: theme.fonts.title1.family,
        fontSize: theme.fontSizes.title1,
        fontWeight: theme.fontWeights.medium,
        letterSpacing: theme.letterSpacings.title1,
        lineHeight: theme.lineHeights.title1
      },
      '.title2': {
        color: theme.colors.title,
        fontFamily: theme.fonts.title2.family,
        fontSize: theme.fontSizes.title2,
        fontWeight: theme.fontWeights.medium,
        letterSpacing: theme.letterSpacings.title2,
        lineHeight: theme.lineHeights.title2
      },
      '.title3': {
        color: theme.colors.title,
        fontFamily: theme.fonts.title3.family,
        fontSize: theme.fontSizes.title3,
        fontWeight: theme.fontWeights.medium,
        letterSpacing: theme.letterSpacings.title3,
        lineHeight: theme.lineHeights.title3
      },
      '.title4': {
        color: theme.colors.title,
        fontFamily: theme.fonts.title4.family,
        fontSize: theme.fontSizes.title4,
        fontWeight: theme.fontWeights.medium,
        letterSpacing: theme.letterSpacings.title4,
        lineHeight: theme.lineHeights.title4
      },
      '.heading1': {
        color: theme.colors.title,
        fontFamily: theme.fonts.heading1.family,
        fontSize: theme.fontSizes.heading1,
        fontWeight: theme.fontWeights.medium,
        letterSpacing: theme.letterSpacings.heading1,
        lineHeight: theme.lineHeights.heading1
      },
      '.heading2': {
        color: theme.colors.title,
        fontFamily: theme.fonts.heading2.family,
        fontSize: theme.fontSizes.heading2,
        fontWeight: theme.fontWeights.medium,
        letterSpacing: theme.letterSpacings.heading2,
        lineHeight: theme.lineHeights.heading2
      },
      '.heading3': {
        color: theme.colors.title,
        fontFamily: theme.fonts.heading3.family,
        fontSize: theme.fontSizes.heading3,
        fontWeight: theme.fontWeights.medium,
        letterSpacing: theme.letterSpacings.heading3,
        lineHeight: theme.lineHeights.heading3
      },
      '.heading4': {
        color: theme.colors.title,
        fontFamily: theme.fonts.heading4.family,
        fontSize: theme.fontSizes.heading4,
        fontWeight: theme.fontWeights.normal,
        letterSpacing: theme.letterSpacings.heading4,
        lineHeight: theme.lineHeights.heading4
      },
      '.body1': {
        fontFamily: theme.fonts.body1.family,
        fontSize: theme.fontSizes.body1,
        fontWeight: theme.fontWeights.medium,
        letterSpacing: theme.letterSpacings.body1,
        lineHeight: theme.lineHeights.body1
      },
      '.body2': {
        fontFamily: theme.fonts.body2.family,
        fontSize: theme.fontSizes.body2,
        fontWeight: theme.fontWeights.normal,
        letterSpacing: theme.letterSpacings.body2,
        lineHeight: theme.lineHeights.body2
      },
      '.body3': {
        fontFamily: theme.fonts.body3.family,
        fontSize: theme.fontSizes.body3,
        fontWeight: theme.fontWeights.medium,
        letterSpacing: theme.letterSpacings.body3,
        lineHeight: theme.lineHeights.body3
      },
      '.body4': {
        fontFamily: theme.fonts.body4.family,
        fontSize: theme.fontSizes.body4,
        fontWeight: theme.fontWeights.normal,
        letterSpacing: theme.letterSpacings.body4,
        lineHeight: theme.lineHeights.body4
      },
      '.caption1': {
        fontFamily: theme.fonts.caption1.family,
        fontSize: theme.fontSizes.caption1,
        fontWeight: theme.fontWeights.medium,
        letterSpacing: theme.letterSpacings.caption1,
        lineHeight: theme.lineHeights.caption1
      },
      '.caption2': {
        fontFamily: theme.fonts.caption2.family,
        fontSize: theme.fontSizes.caption2,
        fontWeight: theme.fontWeights.normal,
        letterSpacing: theme.letterSpacings.caption2,
        lineHeight: theme.lineHeights.caption2
      },
      '.caption3': {
        fontFamily: theme.fonts.caption3.family,
        fontSize: theme.fontSizes.caption3,
        fontWeight: theme.fontWeights.medium,
        letterSpacing: theme.letterSpacings.caption3,
        lineHeight: theme.lineHeights.caption3
      },
      '.caption4': {
        fontFamily: theme.fonts.caption4.family,
        fontSize: theme.fontSizes.caption4,
        fontWeight: theme.fontWeights.normal,
        letterSpacing: theme.letterSpacings.caption4,
        lineHeight: theme.lineHeights.caption4
      },
      body: {
        margin: 0,
        padding: '0 20px',
        color: theme.colors.body,
        fontFamily: theme.fonts.body2.family,
        fontSize: theme.fontSizes.body2,
        letterSpacing: theme.letterSpacings.body2,
        lineHeight: theme.lineHeights.body2,
        '-moz-osx-font-smoothing': 'grayscale',
        '-webkit-font-smoothing': 'antialiased'
      },
      main: {
        padding: isAppWebview ? '24px 0 90px' : '90px 0'
      },
      'input, textarea, button': {
        fontFamily: 'inherit'
      },
      h1: {
        color: theme.colors.title,
        fontFamily: theme.fonts.title3.family,
        fontSize: theme.fontSizes.title3,
        fontWeight: theme.fontWeights.medium,
        letterSpacing: theme.letterSpacings.title3,
        lineHeight: theme.lineHeights.title3,
        margin: '0 0 16px'
      },
      h2: {
        fontFamily: theme.fonts.heading1.family,
        fontSize: theme.fontSizes.heading1,
        fontWeight: theme.fontWeights.medium,
        letterSpacing: theme.letterSpacings.heading1,
        lineHeight: theme.lineHeights.heading1,
        margin: '0 0 16px'
      },
      h3: {
        fontFamily: theme.fonts.heading2.family,
        fontSize: theme.fontSizes.heading2,
        fontWeight: theme.fontWeights.medium,
        letterSpacing: theme.letterSpacings.heading2,
        lineHeight: theme.lineHeights.heading2,
        margin: '0 0 16px'
      },
      h4: {
        fontFamily: theme.fonts.heading3.family,
        fontSize: theme.fontSizes.heading3,
        fontWeight: theme.fontWeights.medium,
        letterSpacing: theme.letterSpacings.heading3,
        lineHeight: theme.lineHeights.heading3,
        margin: '0 0 16px'
      },
      a: {
        color: theme.colors.accent,
        fontSize: 'inherit',
        '&:hover': {
          textDecorationLine: 'underline'
        }
      },
      p: {
        '.large': {
          fontSize: '113.33%',
          lineHeight: '1.41em',
          letterSpacing: '-0.4px'
        }
      },
      small: {
        color: theme.colors.neutral[500],
        fontSize: theme.fontSizes.body4,
        letterSpacing: theme.letterSpacings.body4,
        lineHeight: theme.lineHeights.body4
      },
      strong: {
        fontWeight: theme.fontWeights.medium,
        color: theme.colors.title
      },
      sup: {
        fontSize: 'inherit',
        verticalAlign: 'middle'
      }
    }
  });
};

var _default = Global;
exports["default"] = _default;